import React from 'react';
import PropTypes from 'prop-types';
import Icon from "./IconUtil.js";
import Theme from "./Theme.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Button extends React.Component {
  static contextType = Theme.Context;
  static propTypes = {
    /**
     * CSS class to be applied to this component
     */
    className: PropTypes.string,
    /**
     * Theme variant name to be added to the component
     */
    variant: PropTypes.string,
    /**
     * Function to be called when the button is clicked
     */
    onClick: PropTypes.func,
    /**
     * Data to be be passed through as the data key to the onClick function
     */
    eventData: PropTypes.any,
    /**
     * Whehter to call event.stopPropagation() on `onClick` events
     */
    stopPropagation: PropTypes.bool,
    // eslint-disable-line
    /**
     * Font icon class or url to be rendered as the button's icon
     */
    icon: PropTypes.string,
    // eslint-disable-line
    /**
     * Position of the icon, either before or after the text label
     */
    iconPosition: PropTypes.oneOf(['start', 'end']),
    /**
     * Child elements to be rendered inside of this element
     */
    children: PropTypes.node
  };
  static defaultProps = {
    className: null,
    variant: null,
    onClick: null,
    eventData: null,
    iconPosition: 'start',
    children: null
  };

  /** 
   * (Internal) onClick of the element just adds the eventData prop to the event, and then calls the onClick prop
   */
  onClick = e => {
    const {
      onClick,
      eventData,
      type,
      stopPropagation
    } = this.props;

    // If type is submit, we have to let the default action occur
    // so a form submit is called.
    if (type !== 'submit') {
      e.preventDefault();
    }
    if (stopPropagation !== false) {
      e.stopPropagation();
    }
    if (onClick) {
      onClick({
        data: eventData,
        sourceEvent: e
      });
    }
  };
  render() {
    const theme = this.context;
    const {
      className,
      children,
      variant,
      onClick,
      eventData,
      icon,
      iconPosition,
      imageOpts,
      iconOpts,
      layoutOptions,
      type = 'button',
      stopPropagation,
      domRef,
      ...rest
    } = theme.props('Button', this.props); // eslint-disable-line
    const cn = theme.classes('Button', 'button', variant, className);
    const sCn = theme.subclasses('Button', 'label');
    if (icon && icon !== '') {
      const fChildren = React.Children.map(children, c => {
        return typeof c === 'string' ? /*#__PURE__*/_jsx("span", {
          className: sCn,
          children: c
        }) : c;
      });
      return /*#__PURE__*/ /* eslint-disable react/button-has-type */_jsxs("button", {
        className: cn,
        onClick: this.onClick,
        type: type,
        ...rest,
        ref: domRef,
        children: [icon && iconPosition !== 'end' ? Icon.create(icon, imageOpts, iconOpts, theme) : null, fChildren, icon && iconPosition === 'end' ? Icon.create(icon, imageOpts, iconOpts, theme) : null]
      });
    }

    // put single string in span so ellipsis can work
    let ch = children;
    if (ch && React.Children.count(ch) === 1) {
      ch = React.Children.map(ch, c => {
        return typeof c === 'string' ? /*#__PURE__*/_jsx("span", {
          className: sCn,
          children: c
        }) : c;
      });
    }
    return /*#__PURE__*/_jsx("button", {
      className: cn,
      onClick: this.onClick,
      type: type,
      ...rest,
      ref: domRef,
      children: ch
    })
    /* eslint-enable react/button-has-type */;
  }
}
export default Button;